export const apartmentConstants = {
  //Unit Information
  UNIT_ID_NAME: 'unit_unit_id',
  UNIT_REP_TYPE_NAME: 'unit_rep_type',
  UNIT_APARTMENT_TYPE_NAME: 'unit_apartment_type',
  UNIT_HAS_COUCH_NAME: 'unit_has_couch',
  UNIT_NUMBER_OF_ROOMS_NAME: 'unit_number_of_rooms',
  UNIT_ROOMS_NAME: 'unit_rooms',
  UNIT_NUMBER_OF_BEDS_NAME: 'number_of_beds',
  UNIT_STREET_ADDRESS_NAME: 'unit_address_street',
  UNIT_NOTES_NAME: 'unit_notes',

  UNIT_ID_LABEL: 'Unit ID',
  UNIT_REP_TYPE_LABEL: 'Rep Type',
  UNIT_APARTMENT_TYPE_LABEL: 'Apartment Type',
  UNIT_HAS_COUCH_LABEL: 'Couch',
  UNIT_NUMBER_OF_ROOMS_LABEL: 'Number of Rooms',
  UNIT_ROOMS_LABEL: 'Rooms',
  UNIT_STREET_ADDRESS_LABEL: 'Street Address',
  UNIT_NOTES_LABEL: 'Notes',
  UNIT_NUMBER_OF_BEDS_LABEL: 'Number of beds',

  FURNITURE_FURNISHED_NAME: 'fur_furnished',
  FURNITURE_MONTHLY_COST_NAME: 'fur_monthly_cost',
  FURNITURE_DELIVERY_DATE_NAME: 'fur_furniture_delivery_date',
  FURNITURE_PICKUP_DATE_NAME: 'fur_furniture_pick_up_date',
  FURNITURE_WASHER_DRYER_DELIVERY_DATE_NAME: 'fur_washer_or_dryer_delivery_date',
  FURNITURE_WASHER_DRYER_PICKUP_DATE_NAME: 'fur_washer_or_dryer_pick_up_date',
  FURNITURE_EMAIL_NAME: 'fur_email',
  FURNITURE_PHONE_NAME: 'fur_phone',
  FURNITURE_NOTES_NAME: 'fur_notes',

  FURNITURE_FURNISHED_LABEL: 'Furnished or Unfurnished',
  FURNITURE_MONTHLY_COST_LABEL: 'Furniture Monthly Cost',
  FURNITURE_DELIVERY_DATE_LABEL: 'Furniture Delivery Date',
  FURNITURE_PICKUP_DATE_LABEL: 'Furniture Pickup Date',
  FURNITURE_WASHER_DRYER_DELIVERY_DATE_LABEL: 'Washer/Dryer Delivery Date',
  FURNITURE_WASHER_DRYER_PICKUP_DATE_LABEL: 'Washer/Dryer Pickup Date',
  FURNITURE_EMAIL_LABEL: 'Furniture Company Email',
  FURNITURE_PHONE_LABEL: 'Furniture Company Phone',
  FURNITURE_NOTES_LABEL: 'Notes',

  UTILITIES_IS_ADDED_TO_REP_NAME: 'util_is_added_to_rep',
  UTILITIES_ELECTRIC_ACCOUNT_NUMBER_NAME: 'util_electric_account_number',
  UTILITIES_GAS_ACCOUNT_NUMBER_NAME: 'util_gas_account_number',
  UTILITIES_NOTES_NAME: 'util_notes',

  UTILITIES_IS_ADDED_TO_REP_LABEL: 'Required Utilities Added to Reps Name?',
  UTILITIES_ELECTRIC_ACCOUNT_NUMBER_LABEL: 'Electric Account Number',
  UTILITIES_GAS_ACCOUNT_NUMBER_LABEL: 'Gas Account Number',
  UTILITIES_NOTES_LABEL: 'Notes',

  LEASED_BY_NAME: 'leased_by',
  EXPECTED_RENT_DUE_NAME: 'leased_expected_rent_due',
  RENT_DUE_DATE_NAME: 'leased_rent_due_date',
  EXPECTED_RENT_NAME: 'leased_expected_rent',
  EXPECTED_START_DATE_NAME: 'leased_expected_start_date',
  EXPECTED_END_DATE_NAME: 'leased_expected_end_date',
  ACTUAL_START_DATE_NAME: 'leased_actual_start_date',
  ACTUAL_END_DATE_NAME: 'leased_actual_end_date',
  LEASED_NOTES_NAME: 'lease_notes',

  LEASED_BY_LABEL: 'Leased By',
  EXPECTED_RENT_DUE_LABEL: 'Expected Rent Due',
  RENT_DUE_DATE_LABEL: 'Rent Due Date',
  EXPECTED_RENT_LABEL: 'Expected Rent',
  EXPECTED_START_DATE_LABEL: 'Expected Start Date',
  EXPECTED_END_DATE_LABEL: 'Expected End Date',
  ACTUAL_START_DATE_LABEL: 'Actual Start Date',
  ACTUAL_END_DATE_LABEL: 'Actual End Date',
  LEASED_NOTES_LABEL: 'Notes',

  MOVE_OUT_NOTICE_DATE_LABEL: 'Move-out Notice Date',
  MOVE_OUT_NOTICE_GIVEN_LABEL: 'Move-out Notice Given',
  DATE_MOVE_OUT_NOTICE_WAS_GIVEN_LABEL: 'Date Move Out Notice was Given',
  ACTUAL_MOVE_OUT_DATE_LABEL: 'Actual Move Out Date',
  MOVE_OUT_NOTES_LABEL: 'Notes',

  MOVE_OUT_NOTICE_DATE_NAME: 'move_out_notice_date_name',
  MOVE_OUT_NOTICE_GIVEN_NAME: 'move_out_notice_given_name',
  DATE_MOVE_OUT_NOTICE_WAS_GIVEN_NAME: 'date_move_out_notice_was_given_name',
  ACTUAL_MOVE_OUT_DATE_NAME: 'actual_move_out_date_name',
  MOVE_OUT_NOTES_NAME: 'move_out_notes_name',

  DOCUMENT_UPLOAD_NAME: 'upload_files',
  DOCUMENT_UPLOAD_LABEL: 'Upload Files',

  DELETE_DOCUMENT_CONFIRMATION_TITLE: 'Delete Document?',
  DELETE_DOCUMENT_CONFIRMATION_MESSAGE: 'By deleting this document, you will no longer see it in the list of documents.',
  DELETE_DOCUMENT_CONFIRMATIONS_BUTTON: 'Delete Document',
  DELETE_DOCUMENT_CONFIRMATION_CANCEL: 'Cancel',

  UNIT_INFO_STEP_ID: 1,
  FURNITURE_STEP_ID: 2,
  UTILITIES_STEP_ID: 3,
  LEASE_DETAILS_STEP_ID: 4,
  MOVE_OUT_STEP_ID: 5,
  DOCUMENTS_STEP_ID: 6,
  HISTORY_STEP_ID: 7,

  UNIT_INFO_FORM_TITLE: 'Unit Information',
  FURNITURE_FORM_TITLE: 'Furniture',
  UTILITIES_FORM_TITLE: 'Utilities',
  LEASE_DETAILS_FORM_TITLE: 'Lease Details',
  MOVE_OUT_FORM_TITLE: 'Move Out',
  DOCUMENT_UPLOAD_FORM_TITLE: 'Documents',

  UNIT_INFORMATION_FORM_NAME: 'unit',
  FURNITURE_FORM_NAME: 'furniture',
  LEASE_DETAILS_FORM_NAME: 'lease',
  MOVE_OUT_FORM_NAME: 'move_out',
  UTILITIES_FORM_NAME: 'utilities',
  DOCUMENT_UPLOAD_FORM_NAME: 'file_upload',

  ARCHIVE_COMPLEX_CONFIRMATION_TITLE: 'Archive Complex?',
  ARCHIVE_COMPLEX_CONFIRMATION_MESSAGE: 'By archiving this complex, you will no longer see it in the list of complexes.',
  ARCHIVE_COMPLEX_CONFIRMATIONS_BUTTON: 'Archive Complex',
  ARCHIVE_COMPLEX_CONFIRMATION_CANCEL: 'Cancel',

  ARCHIVE_APARTMENT_CONFIRMATION_TITLE: 'Archive Apartment?',
  ARCHIVE_APARTMENT_CONFIRMATION_MESSAGE: 'By archiving this apartment, you will no longer see it in the list of apartments.',
  ARCHIVE_APARTMENT_CONFIRMATIONS_BUTTON: 'Archive Apartment',
  ARCHIVE_APARTMENT_CONFIRMATION_CANCEL: 'Cancel',

  SEARCH_TYPE_ACTIVE_AND_ARCHIVED: 'active_and_archived',

  HISTORY_UNIT_SECTION: 'unit',
  HISTORY_FURNITURE_SECTION: 'furniture',
  HISTORY_UTILITIES_SECTION: 'utilities',
  HISTORY_LEASE_DETAILS_SECTION: 'lease_details',
  HISTORY_MOVE_OUT_SECTION: 'move_out',
};

export const apartmentMenuItems = [
  {
    id: apartmentConstants.UNIT_INFO_STEP_ID,
    label: apartmentConstants.UNIT_INFO_FORM_TITLE,
  },
  {
    id: apartmentConstants.FURNITURE_STEP_ID,
    label: apartmentConstants.FURNITURE_FORM_TITLE,
  },
  {
    id: apartmentConstants.UTILITIES_STEP_ID,
    label: apartmentConstants.UTILITIES_FORM_TITLE,
  },
  {
    id: apartmentConstants.LEASE_DETAILS_STEP_ID,
    label: apartmentConstants.LEASE_DETAILS_FORM_TITLE,
  },
  {
    id: apartmentConstants.MOVE_OUT_STEP_ID,
    label: apartmentConstants.MOVE_OUT_FORM_TITLE,
  },
  {
    id: apartmentConstants.DOCUMENTS_STEP_ID,
    label: apartmentConstants.DOCUMENT_UPLOAD_FORM_TITLE,
  },
];
